import type { Metadata } from 'contentful';

export const mockMetadata: Metadata = {
  tags: [
    {
      sys: {
        id: 'sportpaleis',
        linkType: 'Tag',
        type: 'Link',
      },
    },
  ],
};
